import { assertWorkspaceActive, guardWorkspaceRequest, isAuthenticationRequest, onWorkspaceRetired } from './workspace'

export function createWorkspaceFetch(fetcher: typeof fetch): typeof fetch {
  return async (input, init) => {
    const url = new URL(input instanceof Request ? input.url : String(input), globalThis.location?.href ?? 'https://localhost')
    if (isAuthenticationRequest(url)) return fetcher(input, init)
    guardWorkspaceRequest(input, init)
    const controller = new AbortController()
    const unsubscribe = onWorkspaceRetired(() => controller.abort())
    const original = init?.signal ?? (input instanceof Request ? input.signal : undefined)
    const abort = () => controller.abort(original?.reason)
    if (original?.aborted) abort()
    else original?.addEventListener('abort', abort, { once: true })
    try {
      const result = await fetcher(input, { ...init, signal: controller.signal })
      assertWorkspaceActive()
      return result
    } finally {
      unsubscribe()
      original?.removeEventListener('abort', abort)
    }
  }
}
